import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { imgUrl, money, categoryName } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const onSale = !!product.sale_price;
  const out = product.stock_status === "out_of_stock";

  return (
    <div className="group" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block">
        <div className="zoom-wrap relative aspect-[3/4] bg-zinc-100">
          {product.images?.[0] ? (
            <img
              src={imgUrl(product.images[0])}
              alt={product.title}
              className="zoom-img h-full w-full object-cover"
              loading="lazy"
            />
          ) : (
            <div className="flex h-full items-center justify-center text-zinc-300">No image</div>
          )}
          <div className="absolute left-3 top-3 flex flex-col gap-2">
            {onSale && (
              <span
                className="bg-kksale px-2.5 py-1 text-[10px] font-medium uppercase tracking-wider text-white"
                data-testid={`sale-badge-${product.id}`}
              >
                On Sale
              </span>
            )}
            {out && (
              <span className="bg-zinc-900 px-2.5 py-1 text-[10px] font-medium uppercase tracking-wider text-white">
                Sold Out
              </span>
            )}
          </div>
          {!out && (
            <button
              onClick={(e) => {
                e.preventDefault();
                addItem(product, 1);
              }}
              className="absolute inset-x-3 bottom-3 flex translate-y-3 items-center justify-center gap-2 bg-zinc-900 py-3 text-xs font-medium uppercase tracking-wider text-white opacity-0 transition-all duration-300 hover:bg-zinc-800 group-hover:translate-y-0 group-hover:opacity-100"
              data-testid={`quick-add-${product.id}`}
            >
              <ShoppingBag size={14} /> Add to Cart
            </button>
          )}
        </div>
      </Link>
      <div className="mt-4">
        <p className="label-eyebrow">{categoryName(product.category)}</p>
        <Link to={`/product/${product.id}`}>
          <h3 className="font-display mt-1 text-base font-normal leading-snug text-zinc-900 hover:text-kkaccent">
            {product.title}
          </h3>
        </Link>
        <div className="mt-1.5 flex items-baseline gap-2">
          {onSale ? (
            <>
              <span className="font-medium text-zinc-900">{money(product.sale_price)}</span>
              <span className="text-sm text-zinc-400 line-through">{money(product.regular_price)}</span>
            </>
          ) : (
            <span className="font-medium text-zinc-900">{money(product.regular_price)}</span>
          )}
        </div>
      </div>
    </div>
  );
};
